import styled from 'styled-components'

export const CloseButton = styled.button`
  position: sticky;
  top: 0;
  left: 100%;
  z-index: 10;
  border: none;
  background-color: inherit;
  border-radius: 100px;
  font-size: 36px;
  width: 42px;
  height: 42px;
  padding: 0;
  transform: rotate(45deg);

  // Firefox
  @supports (-moz-appearance: none) {
    transform: rotate(45deg) translate(-50%, 50%);
  }

  i {
    transform: translate(1px, -6px);
  }

  & + * {
    margin-top: -20px;
  }
`
